module.exports = __webpack_public_path__ + "static/img/CICF_2021_CMYK.2efa25e.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/CICF_2021_CMYK.png
// module id = 5PFM
// module chunks = 1